/**
 * Default project templates that can be bulk-created for an organization.
 * Uses the default_themes and default_folders from sampleData as the base structure.
 */

import { ProjectTheme, ProjectFolder } from "types";

export interface DefaultProjectTemplate {
  name: string;
  themes: ProjectTheme[];
  folders: ProjectFolder[];
}

const defaultThemes: ProjectTheme[] = [
  {
    id: "theme1",
    label: "Administratif",
    steps: [
      {
        id: "step1",
        label: "Études",
        controlpoints: [
          { id: "cp1", label: "Étude géotechnique G2", state: "default" },
          { id: "cp2", label: "Étude béton", state: "default" },
          { id: "cp3", label: "Étude hydrogéologique pour assainissement", state: "default" },
          { id: "cp4", label: "Étude thermique", state: "default" },
        ],
      },
    ],
  },
  {
    id: "theme2",
    label: "VT",
    steps: [
      {
        id: "step2",
        label: "Visite du terrain validée",
        controlpoints: [
          { id: "cp5", label: "Visite du terrain validée", state: "default" },
        ],
      },
    ],
  },
  {
    id: "theme3",
    label: "Mise au point technique",
    steps: [
      {
        id: "step3",
        label: "Mise au point technique",
        controlpoints: [
          { id: "cp6", label: "Réunion technique (MAP)", state: "default" },
        ],
      },
      {
        id: "step4",
        label: "Contrôle mise au point technique",
        controlpoints: [
          { id: "cp7", label: "Validation des plans d'exécution", state: "default" },
          { id: "cp8", label: "Validation des plans de la cuisine", state: "default" },
        ],
      },
    ],
  },
  {
    id: "theme4",
    label: "Avant travaux",
    steps: [
      {
        id: "step5",
        label: "Viabilisation",
        controlpoints: [
          { id: "cp9", label: "EDF", state: "default" },
          { id: "cp10", label: "Télécom", state: "default" },
          { id: "cp11", label: "Gaz", state: "default" },
          { id: "cp12", label: "Eau usée", state: "default" },
          { id: "cp13", label: "Eau potable", state: "default" },
          { id: "cp14", label: "Eaux pluviales", state: "default" },
        ],
      },
      {
        id: "step6",
        label: "Mise en place du panneau de chantier",
        controlpoints: [
          { id: "cp15", label: "Mise en place du panneau de chantier", state: "default" },
        ],
      },
      {
        id: "step7",
        label: "Avant travaux",
        controlpoints: [
          { id: "cp16", label: "Ouverture compteur d'eau", state: "default" },
          { id: "cp17", label: "Pose du compteur provisoire", state: "default" },
          { id: "cp18", label: "Rappel dépôt de la DROC", state: "default" },
        ],
      },
    ],
  },
  {
    id: "theme5",
    label: "Terrassement",
    steps: [
      {
        id: "step8",
        label: "Terrassement",
        controlpoints: [
          { id: "cp19", label: "RDV avec le client sur chantier - contrôle terrassement", state: "default" },
          { id: "cp20", label: "Terrassement", state: "default" },
          { id: "cp21", label: "Accès au chantier", state: "default" },
          { id: "cp22", label: "Évacuation des terres", state: "default" },
        ],
      },
    ],
  },
  {
    id: "theme6",
    label: "Gros œuvre",
    steps: [
      {
        id: "step9",
        label: "Fondations / Dallage",
        controlpoints: [
          { id: "cp23", label: "Programmation intervention du plombier", state: "default" },
          { id: "cp24", label: "Fonds de fouille", state: "default" },
          { id: "cp25", label: "Coulage des fondations", state: "default" },
          { id: "cp26", label: "Validation de l'implantation des rupteurs thermiques", state: "default" },
          { id: "cp27", label: "Limite de propriété correcte", state: "default" },
          { id: "cp28", label: "Présence et contrôle des attentes pour poteaux", state: "default" },
          { id: "cp29", label: "Contrôle réseaux sous dalle", state: "default" },
          { id: "cp30", label: "Présence de la prise de terre (Câblette terre liée aux aciers fondations)", state: "default" },
          { id: "cp31", label: "Nombre des plots sous dalle par rapport à l'étude béton", state: "default" },
          { id: "cp32", label: "Ferraillage de la dalle avant coulage", state: "default" },
          { id: "cp33", label: "Réalisation du soubassement, équerrage", state: "default" },
          { id: "cp34", label: "Réalisation de l'enduit de soubassement", state: "default" },
          { id: "cp35", label: "Coulage de la dalle", state: "default" },
          { id: "cp36", label: "Planéité de la dalle coulée + repérage point haut plateforme", state: "default" },
          { id: "cp37", label: "Remblaiement de la périphérie de la dalle pour sécurité du chantier", state: "default" },
          { id: "cp38", label: "Réalisation du traitement anti-termites", state: "default" },
          { id: "cp39", label: "Mise en place de la bâche anti-radon", state: "default" },
          { id: "cp40", label: "Pose des fourreaux - PTT - EDF - AEP - Raccordements techniques", state: "default" },
          { id: "cp41", label: "Plan de la charpente réceptionné", state: "default" },
          { id: "cp42", label: "Livraison de la charpente", state: "default" },
          { id: "cp43", label: "Livraison des coffres", state: "default" },
        ],
      },
      {
        id: "step10",
        label: "Trait de niveau RDC",
        controlpoints: [
          { id: "cp44", label: "Présence et contrôle du trait de un mètre", state: "default" },
        ],
      },
      {
        id: "step11",
        label: "Trait de niveau Etage",
        controlpoints: [
          { id: "cp45", label: "Présence et contrôle du trait de un mètre", state: "default" },
        ],
      },
      {
        id: "step12",
        label: "Maçonnerie",
        controlpoints: [
          { id: "cp46", label: "Hauteur sous plancher", state: "default" },
          { id: "cp47", label: "Validation des poteaux béton armé", state: "default" },
          { id: "cp48", label: "Élévation des murs", state: "default" },
          { id: "cp49", label: "Positionnement des ouvertures et vérification des dimensions", state: "default" },
          { id: "cp50", label: "Trémie d'escalier dimensions", state: "default" },
          { id: "cp51", label: "Position volets roulants", state: "default" },
          { id: "cp52", label: "Vérification des entrées d'air sur coffre VR", state: "default" },
          { id: "cp53", label: "Présence des sommiers en béton pour recevoir les sabots de la charpente", state: "default" },
          { id: "cp54", label: "Hauteur sous les coffres de VR", state: "default" },
          { id: "cp55", label: "Hauteur arase", state: "default" },
          { id: "cp56", label: "Positionnement du trou d'homme", state: "default" },
          { id: "cp57", label: "Réalisation des seuils et appuis", state: "default" },
          { id: "cp58", label: "Réalisation de la dallette pour PAC", state: "default" },
        ],
      },
      {
        id: "step13",
        label: "Charpente",
        controlpoints: [
          { id: "cp59", label: "Position du CF", state: "default" },
          { id: "cp60", label: "Dimensions du chevêtre", state: "default" },
          { id: "cp61", label: "Validation de la date de la couverture", state: "default" },
          { id: "cp62", label: "Pose de la charpente", state: "default" },
          { id: "cp63", label: "Fixation à la maçonnerie", state: "default" },
          { id: "cp64", label: "Positionnement des réservations pour VELUX", state: "default" },
          { id: "cp65", label: "Pas de contreventement au passage de la trémie", state: "default" },
          { id: "cp66", label: "Contrôle des anti-flambements, contreventements, étrésillons", state: "default" },
          { id: "cp67", label: "Hauteur du dessous des entraits par rapport à la dalle brute", state: "default" },
        ],
      },
      {
        id: "step14",
        label: "Couverture",
        controlpoints: [
          { id: "cp68", label: "Pose de la couverture", state: "default" },
          { id: "cp69", label: "Date d'intervention pour les menuiseries extérieures", state: "default" },
          { id: "cp70", label: "Vérification du bon modèle des tuiles", state: "default" },
          { id: "cp71", label: "Pose des panneaux", state: "default" },
          { id: "cp72", label: "Pose des abouts de faitage", state: "default" },
          { id: "cp73", label: "Mise en place d'un écran sous toiture (si prévu)", state: "default" },
          { id: "cp74", label: "Litonage et contre-litonage (si volige ou écran)", state: "default" },
          { id: "cp75", label: "Mise en place du faîtage (sens du faîtage)", state: "default" },
          { id: "cp76", label: "Scellement bas de pente", state: "default" },
          { id: "cp77", label: "Positionnement et nombre des tuiles à douilles", state: "default" },
          { id: "cp78", label: "Pose de la souche de cheminée", state: "default" },
          { id: "cp79", label: "Étanchéité de la casquette", state: "default" },
          { id: "cp80", label: "Bavette - solin - noue - zinc", state: "default" },
        ],
      },
      {
        id: "step15",
        label: "Toit terrasse - Toit plat",
        controlpoints: [
          { id: "cp81", label: "Plan de réservation des sorties de toiture", state: "default" },
          { id: "cp82", label: "Mise en place des bacs aciers ou de l'OSB", state: "default" },
          { id: "cp83", label: "Pente de 3% pour toit terrasse", state: "default" },
          { id: "cp84", label: "Mise en place de l'isolant de toit (selon étude thermique)", state: "default" },
          { id: "cp85", label: "Remontée d'étanchéité sur les murs (mini 15 cm)", state: "default" },
          { id: "cp86", label: "Mise en place de la membrane d'étanchéité", state: "default" },
          { id: "cp87", label: "Positionnement des évacuations de toit", state: "default" },
          { id: "cp88", label: "Pose du conduit feu", state: "default" },
          { id: "cp89", label: "Positionnement et nombre des trop-pleins", state: "default" },
          { id: "cp90", label: "Pose des couvertines sur acrotères + positionnement des sorties de toiture", state: "default" },
        ],
      },
      {
        id: "step16",
        label: "Menuiseries extérieures",
        controlpoints: [
          { id: "cp91", label: "Pose des menuiseries extérieures", state: "default" },
          { id: "cp92", label: "Date d'intervention enduiseur", state: "default" },
          { id: "cp93", label: "Prise de RDV avec le client sur chantier pour la validation de la pose des menuiseries + remise des clés", state: "default" },
          { id: "cp94", label: "Livraison des portes intérieures", state: "default" },
          { id: "cp95", label: "Aplomb", state: "default" },
          { id: "cp96", label: "Protection des menuiseries", state: "default" },
          { id: "cp97", label: "Vérifier la livraison des produits et état à la livraison", state: "default" },
          { id: "cp98", label: "Présence du compribande", state: "default" },
          { id: "cp99", label: "Présence du joint intérieur", state: "default" },
          { id: "cp100", label: "Présence du joint extérieur", state: "default" },
          { id: "cp101", label: "Jointage autour des appuis de fenêtre", state: "default" },
        ],
      },
      {
        id: "step17",
        label: "Ravalement",
        controlpoints: [
          { id: "cp102", label: "Vérification du ou des coloris d'enduit", state: "default" },
          { id: "cp103", label: "Protection des menuiseries", state: "default" },
          { id: "cp104", label: "Prise de photos des menuiseries extérieures avant ravalement", state: "default" },
          { id: "cp105", label: "Réalisation du dégrossi", state: "default" },
          { id: "cp106", label: "Réalisation de l'enduit", state: "default" },
          { id: "cp107", label: "État du chantier après intervention", state: "default" },
          { id: "cp108", label: "Prise de photos des menuiseries extérieures après ravalement", state: "default" },
        ],
      },
    ],
  },
];

const defaultFolders: ProjectFolder[] = [
  {
    id: "folder_admin",
    name: "Administratif",
    sub_folders: [
      { id: "sub_permis", name: "Permis de construire" },
      { id: "sub_assurance", name: "Assurance" },
      { id: "sub_contrats", name: "Contrats" },
    ],
  },
  {
    id: "folder_technique",
    name: "Technique",
    sub_folders: [
      { id: "sub_plans", name: "Plans d'exécution" },
      { id: "sub_etudes", name: "Études" },
      { id: "sub_be", name: "Bureau d'études" },
    ],
  },
  {
    id: "folder_financier",
    name: "Financier",
    sub_folders: [
      { id: "sub_devis", name: "Devis" },
      { id: "sub_factures", name: "Factures" },
      { id: "sub_avenants", name: "Avenants" },
    ],
  },
  {
    id: "folder_chantier",
    name: "Chantier",
    sub_folders: [
      { id: "sub_photos", name: "Photos de chantier" },
      { id: "sub_cr", name: "Comptes rendus de réunion" },
      { id: "sub_pv", name: "PV de réception" },
    ],
  },
  {
    id: "folder_client",
    name: "Client",
    sub_folders: [
      { id: "sub_correspondance", name: "Correspondance" },
      { id: "sub_notices", name: "Notices descriptives" },
    ],
  },
];

export const defaultProjectTemplates: DefaultProjectTemplate[] = [
  {
    name: "Construction maison individuelle",
    themes: defaultThemes,
    folders: defaultFolders,
  },
];
